﻿import React, { PropsWithChildren } from "react";
import { observer } from "mobx-react";

interface ILegalPartialContainerComponentProps {
    title: string;
    className?: string;
}

interface ILegalPartialContainerComponentState {
    active: boolean;
}

@observer
export class LegalPartialContainerComponent extends React.Component<PropsWithChildren<ILegalPartialContainerComponentProps>, ILegalPartialContainerComponentState> {
    constructor(props: PropsWithChildren<ILegalPartialContainerComponentProps>) {
        super(props);
        this.state = { active: false };
    }

    toggleActive = (event): void => {
        this.setState(prevState => ({
            active: !prevState.active,
        }));
    };

    render() {
        const { active } = this.state;

        return (
            <div className={"legal-partial-container" + (this.props.className ?? "") + (active ? " active" : "")}>
                <h2 onClick={this.toggleActive}>{this.props.title}</h2>
                <div className={"content"}>{this.props.children}</div>
            </div>
        );
    }
}
